import { createElement, FC, ReactNode } from 'react';

export interface SectionLayoutProps {
  id?: string;
  children?: ReactNode;
  element?: string;
  gapBottom?: string;
  gapTop?: string;
  padBottom?: string;
  padTop?: string;
  className?: string;
}

const SectionLayout: FC<SectionLayoutProps> = ({
  id,
  children,
  element = 'section',
  gapBottom = 'lg',
  gapTop = 'none',
  padBottom = 'none',
  padTop = 'none',
  className,
  ...props
}) => {
  let gapTopSizes;
  switch (gapTop) {
    case '2xs':
      gapTopSizes = 'mt-4 md:mt-4 lg:mt-6';
      break;
    case 'xs':
      gapTopSizes = 'mt-8 md:mt-10 lg:mt-12';
      break;
    case 'sm':
      gapTopSizes = 'mt-12 md:mt-14 lg:mt-16';
      break;
    case 'md':
      gapTopSizes = 'mt-16 md:mt-20 lg:mt-24';
      break;
    case 'lg':
      gapTopSizes = 'mt-28 md:mt-32 lg:mt-36';
      break;
    case 'xl':
      gapTopSizes = 'mt-32 md:mt-40 lg:mt-48';
      break;
    case '2xl':
      gapTopSizes = 'mt-48 md:mt-56 lg:mt-64';
      break;
    default:
      gapTopSizes = 'mt-0';
  }

  let gapBottomSizes;
  switch (gapBottom) {
    case 'xs':
      gapBottomSizes = 'mb-8 md:mb-10 lg:mb-12';
      break;
    case 'sm':
      gapBottomSizes = 'mb-12 md:mb-14 lg:mb-16';
      break;
    case 'md':
      gapBottomSizes = 'mb-16 md:mb-20 lg:mb-24';
      break;
    case 'lg':
      gapBottomSizes = 'mb-28 md:mb-32 lg:mb-36';
      break;
    case 'xl':
      gapBottomSizes = 'mb-40 md:mb-44 lg:mb-48';
      break;
    case '2xl':
      gapBottomSizes = 'mb-48 md:mb-56 lg:mb-64';
      break;
    default:
      gapBottomSizes = 'mb-0';
  }

  let padTopSizes;
  switch (padTop) {
    case 'xs':
      padTopSizes = 'pt-8 md:pt-10 lg:pt-12';
      break;
    case 'sm':
      padTopSizes = 'pt-12 md:pt-14 lg:pt-16';
      break;
    case 'md':
      padTopSizes = 'pt-16 md:pt-20 lg:pt-24';
      break;
    case 'lg':
      padTopSizes = 'pt-28 md:pt-32 lg:pt-36';
      break;
    case 'xl':
      padTopSizes = 'pt-12 md:pt-44 lg:pt-48';
      break;
    case '2xl':
      padTopSizes = 'pt-40 md:pt-52 lg:pt-64';
      break;
    default:
      padTopSizes = 'pt-0';
  }

  let padBottomSizes;
  switch (padBottom) {
    case 'xs':
      padBottomSizes = 'pb-8 md:pb-10 lg:pb-12';
      break;
    case 'sm':
      padBottomSizes = 'pb-12 md:pb-14 lg:pb-16';
      break;
    case 'md':
      padBottomSizes = 'pb-16 md:pb-20 lg:pb-24';
      break;
    case 'lg':
      padBottomSizes = 'pb-28 md:pb-32 lg:pb-36';
      break;
    case 'xl':
      padBottomSizes = 'pb-0 md:pb-44 lg:pb-48';
      break;
    case '2xl':
      padBottomSizes = 'pb-40 md:pb-52 lg:pb-64';
      break;
    default:
      padBottomSizes = 'pb-0';
  }

  return createElement(
    element,
    {
      id,
      className: `${gapTopSizes} ${gapBottomSizes} ${padTopSizes} ${padBottomSizes} ${
        className || ''
      }`,
      ...props,
    },
    children
  );
};

export default SectionLayout;
